/**
 * @file: util.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */
import { SvgIconProps } from '@euler/app/components/icons/types';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';

export function useSvgProps<T extends SvgIconProps>(
  { width, height, size, color, fill, ...props }: T,
  defaultWidth: number,
  defaultHeight: number,
) {
  const { rpx } = useResponsiveContext();
  width = width ?? size ?? rpx(defaultWidth);
  height = height ?? size ?? rpx(defaultHeight);
  return {
    width,
    height,
    fill: fill ?? color,
    ...props,
  } as Omit<T, 'size' | 'color'>;
}
